export enum PayableProductInterface {
  LITE = "lite",
  PREMIUM = "premium",
  ULTIMATE = "ultimate"
}
